export function pipToThdCanadaAnalytics(thdPipViewModel, cultureCode) {
  const breadcrumbs = thdPipViewModel.breadcrumbs;
  const _thdPipViewModel$prod = thdPipViewModel.product,
        brand = _thdPipViewModel$prod.Brand,
        productId = _thdPipViewModel$prod.PartnerProductId,
        name = _thdPipViewModel$prod.ProductName,
        MasterCategory = _thdPipViewModel$prod.MasterCategory;
  const _thdPipViewModel$prod2 = thdPipViewModel.productPriceViewModel,
        _thdPipViewModel$prod3 = _thdPipViewModel$prod2.price.originalPrice,
        originalPrice = _thdPipViewModel$prod3 === void 0 ? 0 : _thdPipViewModel$prod3,
        unitPrice = _thdPipViewModel$prod2.discountPrice;
  const vendorDiscount = originalPrice - unitPrice;
  let pageName = '';
  let productCategory = ''; // Get additional data from digitalData global

  if (window.digitalData) {
    var _digitalData$page, _digitalData$page$pag, _product$productInfo;

    const _window = window,
          digitalData = _window.digitalData;
    const product = digitalData == null ? void 0 : digitalData.product[0];
    pageName = digitalData == null ? void 0 : (_digitalData$page = digitalData.page) == null ? void 0 : (_digitalData$page$pag = _digitalData$page.pageInfo) == null ? void 0 : _digitalData$page$pag.pageName;
    productCategory = product == null ? void 0 : (_product$productInfo = product.productInfo) == null ? void 0 : _product$productInfo.productCategory;
  }

  return {
    pageDetail: {
      pageName,
      pageSiteSection: pageName,
      language: (cultureCode == null ? void 0 : cultureCode.split('-')[0]) || 'en',
      breadcrumbs: breadcrumbs == null ? void 0 : breadcrumbs.map(bc => ({
        title: bc.name,
        url: bc.href
      }))
    },
    productOverview: {
      name,
      productId,
      customized: {
        productCategory,
        masterProductCategory: MasterCategory == null ? void 0 : MasterCategory.Name,
        masterProductCategoryId: MasterCategory == null ? void 0 : MasterCategory.CategoryId,
        brand,
        unitPrice,
        basePrice: unitPrice,
        cost: unitPrice,
        eligible: true,
        availableShippingOption: 'standard',
        vendorDiscount
      }
    }
  };
}
export default pipToThdCanadaAnalytics;